// extracted by mini-css-extract-plugin
export default {"components":"Components_components__5gOBR","card":"Components_card__7EQJg","form-group":"Components_form-group__Hl-AW","dragging":"Components_dragging__14XXx"};